
        // Function to show the popup with location information
        function showPopup(location) {
            const popup = document.getElementById('popup');
            const title = document.getElementById('popup-title');
            const description = document.getElementById('popup-description');

            if (location === 'location1') {
                title.textContent = 'The Athletic Company';
                description.textContent = '7260 TX-191 Suite 224 Odessa, TX 79765';
            } else if (location === 'location2') {
                title.textContent = 'Midland Athletic Company';
                description.textContent = '3326 N Midkiff Rd, Midland, TX 79705';
            } else if (location === 'location3') {
                title.textContent = 'The Outfitters of Palo Pinto County';
                description.textContent = 'The Seaman Bldg, 200 W Hubbard St suite 100, Mineral Wells, TX 76067';
            }

            popup.style.display = 'flex';
        }

        // Function to close the popup
        function closePopup() {
            const popup = document.getElementById('popup');
            popup.style.display = 'none';
        }
